var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.item.filename && _vm.item.base64)?[_c('table-control',{attrs:{"type":"download"},on:{"click":function($event){$event.preventDefault();return _vm.download_file()}}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }